import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { OpJobService } from '../../services/op-job.service';

@Component({
  selector: 'app-poster-credential-manager',
  templateUrl: './poster-credential-manager.component.html',
  styleUrls: ['./poster-credential-manager.component.css']
})
export class PosterCredentialManagerComponent  implements OnInit {

  @Input() title: string;
  @Input() message: string;
  @Input() btnOkText: string;
  @Input() btnCancelText: string;

  constructor(private activeModal: NgbActiveModal, private router: Router,private toastr: ToastrService, private jobService: OpJobService) {}

  ngOnInit() {

  }

  routeProductList() {
    // this.router.navigate(["/WebPanel/productListing"], {
    //   queryParams: { id: 1 },
    // });
    this.decline(true);
  }

  sendPoster() {
    this.jobService.sendMail(this.message).subscribe((res: any) => {
      this.toastr.success("Mail Send Successfully", "", {
        positionClass: "toast-top-center",
      });
      this.decline(false);
    },
      (err: any) => {
        if (err.status == 404) {
          this.toastr.error(err.error.message, "POster", {
            positionClass: "toast-top-center",
          });
        } else {
          console.error(err);
        }
      });
  }

  sendPortalLink() {
    this.jobService.sendManager(this.message).subscribe((res: any) => {
      this.toastr.success("Mail Send Successfully", "", {
        positionClass: "toast-top-center",
      });
      this.decline(false);
    },
      (err: any) => {
        if (err.status == 404) {
          this.toastr.error(err.error.message, "POster", {
            positionClass: "toast-top-center",
          });
        } else {
          console.error(err);
        }
      });
  }

  sendBoth() {
    this.jobService.sendPosterAndManager(this.message).subscribe((res: any) => {
      this.toastr.success("Mail Send Successfully", "", {
        positionClass: "toast-top-center",
      });
      this.decline(false);
    },
      (err: any) => {
        if (err.status == 404) {
          this.toastr.error(err.error.message, "POster", {
            positionClass: "toast-top-center",
          });
        } else {
          console.error(err);
        }
      });
    this.decline(false);
  }

  public decline(action) {
    this.activeModal.close(action);
  }

  public accept() {
    this.activeModal.close(true);
  }

  public dismiss() {
    this.activeModal.dismiss();
  }
}
